import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import './ReceiptValidation.css';

const ReceiptValidation = () => {
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    const [adminNotes, setAdminNotes] = useState('');
    const [processing, setProcessing] = useState(false);
    const { currentUser } = useAuth();

    useEffect(() => {
        if (currentUser) {
            fetchPendingReceipts();
        }
    }, [currentUser]);

    const fetchPendingReceipts = async () => {
        try {
            const token = await currentUser.getIdToken();
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/receipts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setReceipts(response.data);
        } catch (error) {
            console.error("Erro ao buscar notas:", error);
            alert("Erro ao carregar notas pendentes.");
        } finally {
            setLoading(false);
        }
    };

    const handleProcess = async (action) => {
        if (!selectedReceipt) return;

        if (action === 'reject' && !adminNotes.trim()) {
            alert("Por favor, adicione uma justificativa para a rejeição.");
            return;
        }

        try {
            setProcessing(true);
            const token = await currentUser.getIdToken();
            await axios.put(
                `http://localhost:5001/api/admin/receipts/${selectedReceipt.id}/process`,
                { action, adminNotes },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            alert(action === 'approve' ? "Nota aprovada! Usuário recebeu 5.000 moedas." : "Nota rejeitada.");
            setSelectedReceipt(null);
            setAdminNotes('');
            fetchPendingReceipts(); // Recarrega a lista
        } catch (error) {
            console.error("Erro ao processar nota:", error);
            alert("Erro ao processar nota.");
        } finally {
            setProcessing(false);
        }
    };

    if (loading) return <div className="loading">Carregando...</div>;

    return (
        <div className="receipt-validation-container">
            <h1>Validação de Notas Fiscais</h1>

            <div className="receipts-grid">
                <div className="receipts-list">
                    <h2>Pendentes ({receipts.length})</h2>
                    {receipts.length === 0 ? (
                        <p className="no-receipts">Nenhuma nota pendente.</p>
                    ) : (
                        receipts.map(receipt => (
                            <div
                                key={receipt.id}
                                className={`receipt-item ${selectedReceipt?.id === receipt.id ? 'active' : ''}`}
                                onClick={() => setSelectedReceipt(receipt)}
                            >
                                <div className="receipt-header">
                                    <span className="store-name">{receipt.storeName}</span>
                                    <span className="value">R$ {receipt.purchaseValue.toFixed(2)}</span>
                                </div>
                                <div className="receipt-date">
                                    {new Date(receipt.createdAt).toLocaleDateString('pt-BR')}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                <div className="receipt-details">
                    {selectedReceipt ? (
                        <>
                            <h2>Detalhes da Nota</h2>
                            <div className="detail-row">
                                <strong>Loja:</strong> {selectedReceipt.storeName}
                            </div>
                            <div className="detail-row">
                                <strong>Valor:</strong> R$ {selectedReceipt.purchaseValue.toFixed(2)}
                            </div>
                            <div className="detail-row">
                                <strong>Data da Compra:</strong> {new Date(selectedReceipt.purchaseDate).toLocaleDateString('pt-BR')}
                            </div>
                            <div className="detail-row">
                                <strong>Enviado em:</strong> {new Date(selectedReceipt.createdAt).toLocaleString('pt-BR')}
                            </div>

                            <div className="receipt-image-container">
                                <img src={selectedReceipt.imageUrl} alt="Comprovante" className="receipt-image" />
                            </div>

                            <div className="admin-notes-section">
                                <label>Observações (rejeição):</label>
                                <textarea
                                    value={adminNotes}
                                    onChange={(e) => setAdminNotes(e.target.value)}
                                    placeholder="Motivo da rejeição..."
                                    rows={3}
                                />
                            </div>

                            <div className="actions">
                                <button
                                    className="btn-approve"
                                    onClick={() => handleProcess('approve')}
                                    disabled={processing}
                                >
                                    <i className="fas fa-check-circle"></i> Aprovar (+5.000)
                                </button>
                                <button
                                    className="btn-reject"
                                    onClick={() => handleProcess('reject')}
                                    disabled={processing}
                                >
                                    <i className="fas fa-times-circle"></i> Rejeitar
                                </button>
                            </div>
                        </>
                    ) : (
                        <div className="no-selection">
                            <i className="fas fa-hand-pointer"></i>
                            <p>Selecione uma nota para visualizar</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReceiptValidation;
